"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ADDITIONAL_AMENDMENTS", {
  enumerable: true,
  get: function get() {
    return _supersizeMyEdit.ADDITIONAL_AMENDMENTS;
  }
});
Object.defineProperty(exports, "ADDITIONAL_MEDIA", {
  enumerable: true,
  get: function get() {
    return _supersizeMyEdit.ADDITIONAL_MEDIA;
  }
});
Object.defineProperty(exports, "Addon", {
  enumerable: true,
  get: function get() {
    return _types.Addon;
  }
});
Object.defineProperty(exports, "AddonStatus", {
  enumerable: true,
  get: function get() {
    return _types.AddonStatus;
  }
});
Object.defineProperty(exports, "Addons", {
  enumerable: true,
  get: function get() {
    return _types.Addons;
  }
});
Object.defineProperty(exports, "ComplexAddon", {
  enumerable: true,
  get: function get() {
    return _types.ComplexAddon;
  }
});
Object.defineProperty(exports, "OTHER", {
  enumerable: true,
  get: function get() {
    return _supersizeMyEdit.OTHER;
  }
});
Object.defineProperty(exports, "Output", {
  enumerable: true,
  get: function get() {
    return _types.Output;
  }
});
Object.defineProperty(exports, "OutputSummary", {
  enumerable: true,
  get: function get() {
    return _types.OutputSummary;
  }
});
Object.defineProperty(exports, "OutputVersion", {
  enumerable: true,
  get: function get() {
    return _types.OutputVersion;
  }
});
Object.defineProperty(exports, "SIMPLE_GRAPHICS", {
  enumerable: true,
  get: function get() {
    return _supersizeMyEdit.SIMPLE_GRAPHICS;
  }
});
Object.defineProperty(exports, "SUPERSIZE_MY_EDIT", {
  enumerable: true,
  get: function get() {
    return _supersizeMyEdit.SUPERSIZE_MY_EDIT;
  }
});
Object.defineProperty(exports, "addonsWithMultipleValues", {
  enumerable: true,
  get: function get() {
    return _supersizeMyEdit.addonsWithMultipleValues;
  }
});
Object.defineProperty(exports, "getAddonsList", {
  enumerable: true,
  get: function get() {
    return _utils.getAddonsList;
  }
});
Object.defineProperty(exports, "getAddonsTotalCost", {
  enumerable: true,
  get: function get() {
    return _utils.getAddonsTotalCost;
  }
});
Object.defineProperty(exports, "getOutputAddonsReport", {
  enumerable: true,
  get: function get() {
    return _utils.getOutputAddonsReport;
  }
});
Object.defineProperty(exports, "getOutputSummary", {
  enumerable: true,
  get: function get() {
    return _utils.getOutputSummary;
  }
});
Object.defineProperty(exports, "getOutputSummaryWithAdditionalOutputs", {
  enumerable: true,
  get: function get() {
    return _utils.getOutputSummaryWithAdditionalOutputs;
  }
});
Object.defineProperty(exports, "getOutputVersionSummary", {
  enumerable: true,
  get: function get() {
    return _utils.getOutputVersionSummary;
  }
});
var _supersizeMyEdit = require("./constants/supersizeMyEdit");
var _utils = require("./utils");
var _types = require("./types");